import { EstadoUiVm } from './EstadoUiVm';

export class EstadoUiUtil {
  estadoUiVm: EstadoUiVm = new EstadoUiVm();

  recuperarEstado(): Promise<void> {
    return new Promise(resolve => {
      setTimeout(() => {
        this.estadoUiVm.objeto = {
          coordenadas: {
            lat: -33.4372,
            lng: -70.6506,
          },
          zoom: 13,
          filtro: 0,
          elementosSeleccionados: [],
          primerInicio: true,
          unidadSeleccionada: '',
          grupoZonas: [],
        };
        resolve();
      }, 1000);
    });
  }

  guardarEstado(): Promise<any> {
    return Promise.resolve();
  }
}
